import React, {useEffect, useState} from 'react';
import {Button, Skeleton, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {useFacets} from '../../contexts/AggsContext';

export default function DeferredFacets({fields = [], children}) {
    const {t} = useTranslation();
    const {ready, failed, retry} = useFacets(fields);
    const [mounted, setMounted] = useState(false);
    useEffect(() => { if(ready) setMounted(true); }, [ready]);
    const pending = failed ? <Space role="status">
        {t('facet-counts-failed', 'Could not load counts.')}
        <Button size="small" onClick={retry}>{t('retry', 'Retry')}</Button>
    </Space> : <div role="status" aria-label={t('loading-counts', 'Loading counts')}><Skeleton active paragraph={{rows: 2}} title={false}/></div>;
    // Keep open controls and expanded date nodes mounted through a search;
    // hide their obsolete counts until the matching response arrives.
    return <>
        {!ready && pending}
        <div hidden={!ready}>{(mounted || ready) && children}</div>
    </>;
}
